/** Fallback IANA zone when the runtime cannot resolve the user zone (header must always be sent). */
const FALLBACK_USER_TIMEZONE = "Etc/UTC";

/**
 * IANA timezone (e.g. Asia/Kolkata) for `X-User-Timezone` on API requests.
 * Never returns null — use {@link FALLBACK_USER_TIMEZONE} if detection fails.
 */
export function getUserTimeZone() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof tz === "string") {
      const t = tz.trim();
      if (t !== "") {
        // Legacy IANA id still reported by some runtimes
        if (t.toLowerCase() === "asia/calcutta") return "Asia/Kolkata";
        return t;
      }
    }
  } catch {
    /* ignore */
  }
  return FALLBACK_USER_TIMEZONE;
}

/** Always includes `X-User-Timezone` so backends receive a zone on every request. */
export function userTimezoneHeaders() {
  return { "X-User-Timezone": getUserTimeZone() };
}
